export default __webpack_public_path__ + "static/media/slide1.1c1b4d57.png";